import { expValEquals } from '@confluence/feature-experiments';
import {
	useGetOnboardingState,
	deserializeState,
} from '@confluence/onboarding-helpers/entry-points/hooks/useOnboardingState.ts';
import { LAND_USERS_IN_EDITOR_WITH_REVAMPED_BPQA } from '@confluence/onboarding-helpers/entry-points/constants/onboarding-state-constants.ts';
import { useIsLicensed } from '@confluence/session-data/entry-points/useAccessStatus.ts';

import { isWithinLastWeek } from '../utils/isWithinLastWeek.ts';

export const useShouldShowNewUserTemplates = () => {
	const isLicensed = useIsLicensed();

	const { data, loading, error } = useGetOnboardingState(
		[...Object.values(LAND_USERS_IN_EDITOR_WITH_REVAMPED_BPQA)],
		!isLicensed,
	);
	const { revampedBpqaShownAt } = deserializeState(data);
	const shownAtWithinLastWeek = isWithinLastWeek(revampedBpqaShownAt);

	if (!isLicensed) {
		return { showNewUserTemplates: false, loading: false };
	}

	if (loading) {
		return { showNewUserTemplates: false, loading: true };
	}

	if (error) {
		return { showNewUserTemplates: false, loading: false, error };
	}

	return {
		showNewUserTemplates:
			shownAtWithinLastWeek &&
			(expValEquals('land_users_in_editor_with_revamped_bpqa_new', 'cohort', 'experiment') ||
				expValEquals('land_users_in_editor_with_revamped_bpqa_existing', 'cohort', 'experiment')),
		loading: false,
	};
};
